module.exports = __webpack_public_path__ + "static/media/hamburger-icon.0b348ef4.svg";